import { ACTION_TYPES } from './weather.types';

export const setWeather = (weather) => {
	return { type: ACTION_TYPES.SET_WEATHER, payload: weather };
}

export const removeWeather = () => {
	return { type: ACTION_TYPES.REMOVE_WEATHER, payload: '' };
}
